import React from 'react'

export default function Experience() {
    return (
      <>
        <div className="container-fluid">
        <section>
          <main className="offset-md-2 my-3 px-3 pt-3" id="experience">
          <h1 className="title">Experience</h1>
              <div className="container py-4">
          <div className="d-flex justify-content-between"><h3>Communication Excecutive</h3><p class="my-0" style={{ color: "#bd5d38" }}><strong>2015 - 2019</strong></p></div>
          <h4 className="description">A.M Studio</h4>
          <p className="my-0">Experienced start-up company mainly focusing on 3D architectural visualization and concept designing.</p>
          </div>

          <div className="container py-4">
          <div className="d-flex justify-content-between"><h3>English Translator and Interpreter</h3><p class="my-0" style={{ color: "#bd5d38" }}><strong>2016 - Present</strong></p></div>
          <h4 className="description">Freelance</h4>
          <p className="my-0">Convert the written & spoken word from English to Vietnamese and vice versa to ensure the original meaning is retained. Proofread, edit, and revise translated materials. Listen to speakers' statements to determine meanings and to prepare translations.</p>
          </div>
          </main>
        </section>
      </div>
      <hr></hr>
      </>
    )
}
